import script from "./UserSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSwitch.vue?vue&type=script&setup=true&lang=js"

import "./UserSwitch.vue?vue&type=style&index=0&id=8d83d512&lang=css"

const __exports__ = script;

export default __exports__